import { CycleTimeModel } from '@/libs/Api';
import { graphqlPost } from '@/libs/tpm-analytics/graphql/transport';
import { buildCycleTimesQuery } from '@/libs/tpm-analytics/graphql/queries';

export class CycleTimesRepository {
    static async fetchAllCycleTimes(): Promise<CycleTimeModel[]> {
        const query = buildCycleTimesQuery();
        const data = await graphqlPost<any>(query, {});
        const list = data?.cycleTimes ?? [];
        return Array.isArray(list) ? (list as CycleTimeModel[]) : [];
    }
}


